import {Box} from '@mui/material';

const Cushion = ({...props}) => {
  return <Box sx={{height: (theme) => theme.spacing(10)}} {...props}></Box>;
};

export {Cushion};
